<template>
    <div class="d-inline-block">
        {{ from }}&nbsp;&ndash;&nbsp;{{ to }}
    </div>
</template>
<script>
    /**
     * DO NOT PUT STYLES HERE.
     * DO NOT PUT LOGIC HERE.
     */

    export default {
        props: {
            from: 0,
            to: 0
        }
    }
</script>
